<template>
  <div class="app-container">
    <el-row :gutter="20">
      <el-col :span="24" :xs="24">
        <!-- 搜索表单 -->
        <el-form :model="queryParams" ref="queryForm" size="small" v-show="showSearch" label-width="100px">
          <el-row :gutter="24" type="flex" justify="right">
            <el-col :span="8">
              <el-form-item label="检测日期" prop="testEmployeeDate">
                <el-date-picker v-model="queryParams.testEmployeeDate" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd"
                                style="width: 100%;" @change="handleSearch" />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="客户名称" prop="compNames">
                <el-input v-model="queryParams.compNames" placeholder="请输入客户名称" @keyup.enter.native="handleSearch" />
                <CustomerDetails v-model="queryParams.compNames" />
              </el-form-item>
            </el-col>
          </el-row>

          <!-- 功能按钮区域 -->
          <div style="text-align: center;margin-bottom: 10px;">
            <PermissionMethodToolbar :url="url" :id="'toolbar'" @handleSearch="handleSearch" @handleReset="handleReset" @exportToExcel="exportToExcel" />
          </div>

          <!-- 数据表格 -->
          <el-table id="table" :data="tableData" border style="width: 100%; margin-top: 20px" :header-cell-style="{ background: '#d8e8fb', textAlign: 'left', borderColor: '#CCC' }" height="500"
                    v-loading="loading" show-summary :summary-method="getSummaries" :span-method="tableSpanMethod">
            <el-table-column type="index" label="序号" align="center" fixed="left" width="50"></el-table-column>
            <el-table-column label="客户名称" align="left" prop="compName" min-width="160" show-overflow-tooltip />
            <el-table-column label="使用单位" align="left" prop="usingUnit" min-width="160" show-overflow-tooltip />
            <el-table-column label="检测台数" align="left" prop="countNum" min-width="260" show-overflow-tooltip />
            <el-table-column label="标准金额" align="left" prop="testCharge" min-width="100" show-overflow-tooltip />
            <el-table-column label="折扣金额" align="left" prop="ratioPrice" min-width="120" show-overflow-tooltip />
            <el-table-column label="折扣比例" align="left" prop="ratio" min-width="100" show-overflow-tooltip />
            <el-table-column label="应收金额" align="left" prop="totalTestAmount" min-width="120" show-overflow-tooltip />
            <el-table-column label="实收金额" align="left" prop="actualReceiptAmount" min-width="120" show-overflow-tooltip />
            <el-table-column label="居间费/确认后返点费" align="left" prop="rebatePrice" min-width="180" show-overflow-tooltip />
            <el-table-column label="配合费" align="left" prop="cooperationFee" min-width="120" show-overflow-tooltip />
            <el-table-column label="净产值" align="left" prop="netOutputValue" min-width="120" show-overflow-tooltip />
          </el-table>
          <!-- 分页组件 -->
          <el-pagination style="margin-top: 10px; text-align: right;" @size-change="handleSizeChange" @current-change="handlePageChange" :current-page="queryParams.currPage"
                         :page-sizes="[10, 20, 50, 100, 200, 500, 1000]" :page-size="queryParams.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total" />
        </el-form>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { queryProductionSheet, exportProductionSheet } from '@/api/contract/contract'
import PermissionMethodToolbar from '@/components/button/PermissionMethodToolbar.vue'

export default {
  name: 'OutputStatistics',
  props: {
    // 页面URL，用于权限按钮组件
    url: {
      type: String,
      default: ''
    }
  },
  components: {
    PermissionMethodToolbar
  },
  data () {
    return {
      showSearch: true,
      loading: false,
      tableData: [],
      compNameRowspans: [],
      queryParams: {
        compNames: '',
        testEmployeeDate: [],
        currPage: 1,
        pageSize: 200
      },
      total: 0
    }
  },
  created () {
    this.getList()
  },
  methods: {
    buildParams () {
      const params = {
        currPage: this.queryParams.currPage,
        pageSize: this.queryParams.pageSize
      }

      if (this.queryParams.compNames) {
        params.compNames = this.queryParams.compNames
      }

      if (Array.isArray(this.queryParams.testEmployeeDate) && this.queryParams.testEmployeeDate.length === 2) {
        params.testEmployeeDate = this.queryParams.testEmployeeDate
      }

      return params
    },

    normalizeList (res) {
      // 兼容后端返回：{ retCode:'ok', additionalData: { list/records } } 或者 additionalData 直接是数组
      if (res && res.retCode === 'ok') {
        const ad = res.additionalData
        if (Array.isArray(ad)) return ad
        if (ad && Array.isArray(ad.records)) return ad.records
        if (ad && Array.isArray(ad.list)) return ad.list
        return []
      }

      // 兜底：直接返回数组
      if (Array.isArray(res)) return res
      if (res && Array.isArray(res.additionalData)) return res.additionalData
      return []
    },

    // 查询（按钮 emit: handleSearch）
    handleSearch () {
      // 查询从第一页开始
      this.queryParams.currPage = 1
      this.getList()
    },

    // 重置（按钮 emit: handleReset）
    handleReset () {
      this.queryParams.compNames = ''
      this.queryParams.testEmployeeDate = []
      this.queryParams.currPage = 1
      this.getList()
    },

    // 修改每页条数
    handleSizeChange (size) {
      this.queryParams.pageSize = size
      this.queryParams.currPage = 1
      this.getList()
    },

    // 分页切换页码
    handlePageChange (page) {
      this.queryParams.currPage = page
      this.getList()
    },

    // 列表查询
    getList () {
      this.loading = true
      const params = this.buildParams()

      queryProductionSheet(params).then(res => {
        // 处理分页信息
        if (res && res.retCode === 'ok' && res.additionalData) {
          const ad = res.additionalData
          this.total = ad.total || 0
          if (ad.current !== undefined) {
            this.queryParams.currPage = ad.current
          }
          if (ad.size !== undefined) {
            this.queryParams.pageSize = ad.size
          }
        }

        const list = this.normalizeList(res) || []
        this.tableData = list
        this.compNameRowspans = this.buildCompNameRowspans(list)
        this.loading = false
      }).catch(error => {
        console.error('查询失败:', error)
        this.$message.error('查询失败：' + (error.message || '未知错误'))
        this.tableData = []
        this.compNameRowspans = []
        this.loading = false
      })
    },

    // 生成“客户名称”列的行合并信息（仅合并连续且相同的客户）
    buildCompNameRowspans (list) {
      const rowspans = []
      let startIndex = 0
      const safeList = list || []

      safeList.forEach((item, index) => {
        if (index === 0) {
          rowspans.push(1)
          return
        }

        if (item.compName === safeList[index - 1].compName) {
          rowspans[startIndex] += 1
          rowspans.push(0)
        } else {
          startIndex = index
          rowspans.push(1)
        }
      })

      return rowspans
    },

    // el-table 单元格合并：仅合并“客户名称”列
    // 注意：compNameRowspans 里被合并掉的行值为 0，不能用 `|| 1`，否则 0 会变成 1，表格局部多格，后面各列会整列错位。
    tableSpanMethod ({ column, rowIndex }) {
      if (column.property !== 'compName') {
        return [1, 1]
      }
      const span = this.compNameRowspans[rowIndex]
      if (span === 0) {
        return [0, 0]
      }
      if (span === undefined || span === null) {
        return [1, 1]
      }
      return [span, 1]
    },

    // 导出（按钮 emit: exportToExcel）
    exportToExcel () {
      this.$message.success('正在导出产值统计数据...')
      const params = this.buildParams()

      exportProductionSheet(params).then(response => {
        const blob = new Blob([response], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
        const url = window.URL.createObjectURL(blob)

        const link = document.createElement('a')
        link.href = url
        link.download = '产值统计.xlsx'

        link.style.display = 'none'
        document.body.appendChild(link)
        link.click()

        document.body.removeChild(link)
        window.URL.revokeObjectURL(url)

        this.$message.success('导出成功')
      }).catch(error => {
        console.error('导出失败:', error)
        this.$message.error('导出失败：' + (error.message || '未知错误'))
      })
    },

    toNumber (val) {
      if (val === null || val === undefined || val === '') return 0
      const n = Number(val)
      return Number.isFinite(n) ? n : 0
    },

    formatSum (property, sum) {
      if (property === 'countNum') {
        return String(Math.round(sum))
      }
      // 金额类统一保留2位
      return sum.toFixed(2)
    },

    // el-table 合计行
    getSummaries ({ columns, data }) {
      const sums = []
      const noSumProps = ['compName']
      const ratioProp = 'ratio'
      const sumProps = ['countNum', 'testCharge', 'ratioPrice', 'finalPrice', 'rebatePrice', 'actualReceiptAmount', 'cooperationFee', 'netOutputValue']

      columns.forEach((column, index) => {
        const prop = column.property

        // 无prop的列（如果未来加了序号列等）
        if (!prop) {
          sums[index] = ''
          return
        }

        if (noSumProps.includes(prop)) {
          sums[index] = '合计'
          return
        }

        if (prop === ratioProp) {
          sums[index] = '-'
          return
        }

        if (!sumProps.includes(prop)) {
          sums[index] = ''
          return
        }

        const total = (data || []).reduce((acc, row) => acc + this.toNumber(row[prop]), 0)
        sums[index] = this.formatSum(prop, total)
      })

      return sums
    }
  }
}
</script>

<style scoped>
.app-container {
  padding: 20px;
}
</style>
